<template>
  <div>
    <el-upload action='string' list-type="picture-card" :auto-upload="false"
      :on-change="consoleFL">
      <i class="el-icon-plus"></i>
    </el-upload>

    <el-dialog :visible.sync="cropperModel" width="1100px" :before-close="beforeClose" append-to-body
      :close-on-click-modal="false">
      <Cropper :img-file="fileurl" :skuname="skufilekey" ref="vueCropper" v-on:upload="uploadproductimg">
      </Cropper>
    </el-dialog>
  </div>
</template>

<script>
  import Cropper from '../../components/utils/cropper.vue'
  export default {

    components: {
      Cropper
    },
    data() {
      return {
        file: null,
        fileurl: '',
        skufilekey: '',
        cropperModel: false,
        fileList2: []
      }
    },
    methods: {
      consoleFL(file, fileList) {
        // 弹出剪裁框，将当前文件设置为文件
        // console.log(file.url);
        // console.log(file);
        debugger
        this.file = file;
        this.fileurl = file.url;
        this.skufilekey = '';
        this.cropperModel = true;

      },
      beforeClose() {
        //判断是否点击的商品图片打开的裁剪框
        if (this.skufilekey == '') {
          //点击关闭刷新商品图片展示
          this.fileList2.push(this.file);
          this.fileList2.pop();
        }
        this.cropperModel = false;
      },
      uploadproductimg(data, key) {
        debugger
        console.log(data)
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/page/test/TestCorpper.vue